import { put, call, select } from 'redux-saga/effects';
import { push } from 'redux-first-history';
import ApiInstance from '../../helpers/apiInstance';
import { sendRequest } from '../../helpers/saga';
import actions from './actions';
import { IMeApiResponse } from './types';
import { RootState } from '../store';

// @ts-ignore
const { REACT_APP_LOGIN_URL: loginUrl } = import.meta.env;
const api = new ApiInstance('me', '/v1', 'UnifiedLogin');

// TODO: fix types
function* validateSessionRequest(): Generator<any, void, any> {
  const result: IMeApiResponse = yield call(sendRequest, api.get, {}, actions.VALIDATE_SESSION_ERROR);

  if (result?.status === 200 && result.data?.user) {
    const { organizations, user } = result.data || {};

    yield put(actions.validateSessionSuccess(result.data));

    const state = yield select() as RootState;
    const profile = state?.Auth?.profile;
    const sessionOrg = organizations?.find(org => org?.active);

    const buildRedirectUrl = () => {
      const email = user?.email;
      const organizationId = sessionOrg?.id;
      const roles = encodeURIComponent(sessionOrg?.roles?.map(role => role.id).join('&') ?? '');
      const params = `email=${email}&organization_id=${organizationId}&role_id=${roles}`;

      return `${loginUrl}/active-session?${params}`;
    };

    const isCorrectUser = profile?.email === user?.email;
    const hasAdminRole = sessionOrg?.roles?.some(role => role.id === 'admin');

    if (isCorrectUser && hasAdminRole) {
      return;
    }

    if (hasAdminRole) {
      // user should be logged in
      yield put(push('/'));

      return;
    }

    window.location.href = buildRedirectUrl();
  } else {
    yield put(actions.validateSessionError());
  }
}

export { validateSessionRequest };
